import { styled, keyframes } from '@mui/system'
import { colors, fontSizes } from '../../../../Components/consts'
import { ON_CLOCK_ANIMATION_DURATION } from '../../../../Constants/draft'

const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(50px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`

const fadeOutUp = keyframes`
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(-50px);
  }
`

export const OnTheClockWrapper = styled('div')(({ theme }) => ({
  position: 'fixed',
  bottom: 16,
  left: '50%',
  transform: 'translateX(-50%)',
  zIndex: 50,
  width: '100%',
  maxWidth: 400,
  paddingLeft: 16,
  paddingRight: 16,
  [theme.breakpoints.down('md')]: {
    maxWidth: 325,
    paddingLeft: 12,
    paddingRight: 12,
  },
}))

export const OnTheClockCard = styled('div')<{
  animationState: 'entering' | 'exiting' | 'idle'
}>(({ animationState }) => ({
  background: `linear-gradient(to bottom right, ${colors.yellow}, rgb(253, 250, 225))`,
  color: colors.gray.gray80,
  borderRadius: 8,
  boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
  overflow: 'hidden',
  animation: `
    ${
      animationState === 'entering'
        ? fadeInUp
        : animationState === 'exiting'
        ? fadeOutUp
        : 'none'
    } 
    ${ON_CLOCK_ANIMATION_DURATION}s ease-in-out forwards
  `,
}))

export const OnTheClockContent = styled('div')(({ theme }) => ({
  padding: 12,
  display: 'flex',
  alignItems: 'center',
  gap: 16,
  [theme.breakpoints.down('md')]: {
    gap: 12,
  },
}))

export const LogoContainer = styled('div')<{ teamColor?: string }>(({ theme, teamColor }) => ({
  flexShrink: 0,
  width: 48,
  height: 48,
  borderRadius: '50%',
  backgroundColor: teamColor ?? colors.black,
  padding: 6,
  boxShadow: 'inset 0 2px 4px 0 rgba(0, 0, 0, 0.06)',
  [theme.breakpoints.down('md')]: {
    width: 36,
    height: 36,
  },
  '& img': {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  },
}))

export const TextInfo = styled('div')({
  flex: 1,
})

export const TeamName = styled('h3')(({ theme }) => ({
  fontWeight: 'bold',
  fontSize: fontSizes.semiLarge,
  marginTop: 0,
  marginBottom: 4,
  [theme.breakpoints.down('md')]: {
    fontSize: fontSizes.medium,
  },
}))

export const PickInfo = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 4,
  fontSize: fontSizes.small,
  [theme.breakpoints.down('md')]: {
    fontSize: fontSizes.xSmall,
  },
}))

export const PickNumber = styled('span')(({ theme }) => ({
  fontWeight: 600,
  [theme.breakpoints.down('md')]: {
    fontWeight: 800,
  },
}))

export const DotSeparator = styled('span')({
  opacity: 0.75,
})

export const BadgeContainer = styled('div')(({ theme }) => ({
  flexShrink: 0,
  border: `1px solid ${colors.black}`,
  padding: theme.spacing(2, 3),
  borderRadius: 99,
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(1, 2),
  },
}))

export const BadgeText = styled('span')(({ theme }) => ({
  fontWeight: 800,
  fontSize: fontSizes.small,
  textTransform: 'uppercase',
  letterSpacing: '0.05em',
  color: colors.black,
  [theme.breakpoints.down('md')]: {
    fontSize: fontSizes.xSmall,
  },
}))
